var map = {
	"./template.bet575": 1718,
	"./template.bet575.tsx": 1718,
	"./template.bet777": 1719,
	"./template.bet777.tsx": 1719,
	"./template.betbetbet": 1720,
	"./template.betbetbet.tsx": 1720,
	"./template.betprofessor": 1721,
	"./template.betprofessor.tsx": 1721,
	"./template.betroyale": 1722,
	"./template.betroyale.tsx": 1722,
	"./template.betstride": 1723,
	"./template.betstride.tsx": 1723,
	"./template.buffalobet": 1984,
	"./template.buffalobet.tsx": 1984,
	"./template.chromabet": 1724,
	"./template.chromabet.tsx": 1724,
	"./template.default": 673,
	"./template.default.tsx": 673,
	"./template.epicodds": 1725,
	"./template.epicodds.tsx": 1725,
	"./template.fiestabet": 1726,
	"./template.fiestabet.tsx": 1726,
	"./template.forsport": 1727,
	"./template.forsport.tsx": 1727,
	"./template.gigabet": 1728,
	"./template.gigabet.tsx": 1728,
	"./template.goldenbet888": 1729,
	"./template.goldenbet888.tsx": 1729,
	"./template.goldenrush": 1730,
	"./template.goldenrush.tsx": 1730,
	"./template.hyperbet": 1731,
	"./template.hyperbet.tsx": 1731,
	"./template.juicybet": 1732,
	"./template.juicybet.tsx": 1732,
	"./template.junglebet": 1733,
	"./template.junglebet.tsx": 1733,
	"./template.magnumbet": 1734,
	"./template.magnumbet.tsx": 1734,
	"./template.oldgill": 1735,
	"./template.oldgill.tsx": 1735,
	"./template.puntcity": 1736,
	"./template.puntcity.tsx": 1736,
	"./template.puntgenie": 1737,
	"./template.puntgenie.tsx": 1737,
	"./template.pyramidbet": 1738,
	"./template.pyramidbet.tsx": 1738,
	"./template.questbet": 1739,
	"./template.questbet.tsx": 1739,
	"./template.slambet": 1740,
	"./template.slambet.tsx": 1740,
	"./template.sterlingparker": 1741,
	"./template.sterlingparker.tsx": 1741,
	"./template.sugarcastle": 1742,
	"./template.sugarcastle.tsx": 1742,
	"./template.templebet": 1743,
	"./template.templebet.tsx": 1743,
	"./template.titanbet": 1746,
	"./template.titanbet.tsx": 1746,
	"./template.ts": 987,
	"./template.vikingbet": 1747,
	"./template.vikingbet.tsx": 1747,
	"./template.volcanobet": 1748,
	"./template.volcanobet.tsx": 1748,
	"./template.wellbet": 1749,
	"./template.wellbet.tsx": 1749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2476;